import baseRoute from '../baseRoute';

export default `${baseRoute}/item` as const;
